/**
 * 회사 코드 UI 상수
 *
 * CompanyCode 타입은 shared/types/employee.ts에 정의.
 * 이 파일은 드롭다운 등 FE UI에서 사용하는 라벨 매핑만 관리.
 */
import type { CompanyCode } from '../types/employee';

/** 회사 코드 드롭다운 옵션 (SSoT) */
export const COMPANY_CODE_OPTIONS: Array<{ value: CompanyCode; label: string }> = [
  { value: 'KR', label: 'KR - 한국 법인' },
  { value: 'CN', label: 'CN - 중국 법인' },
];
